import { ensure } from "sprint-common-web";

import { ContentSubtype } from "../../../../../../common/types/ContentSubtype";
import { LookupCloudAssetItem } from "../../../../lookup-cloud-asset/LookupCloudAssetItem";
import { useSetLookupContent } from "../hooks/useSetLookupContent";

export const useAssociateLookupCloudAsset = () => {
    const { setMovieContent, setTvContent, setAncillaryContent } = useSetLookupContent();

    const setContentFromLookupCloudAsset = (item: LookupCloudAssetItem) => {
        ensure(item.content.subtype);
        switch (item.content.subtype) {
            case ContentSubtype.Movie:
            case ContentSubtype.TvSingle:
            case ContentSubtype.FeatureDocumentary:
            case ContentSubtype.ShortFilm: {
                setMovieContent(
                    item.content.movie.id,
                    item.content.versions.map((v) => v.id)
                );

                break;
            }

            case ContentSubtype.TV: {
                ensure(item.content.season);
                ensure(item.content.episode);

                setTvContent({
                    tvSeriesId: item.content.tvSeries.id,
                    seasonId: item.content.season?.id,
                    episodeId: item.content.episode?.id,
                    versionIds: item.content.versions.map((v) => v.id)
                });

                break;
            }

            case ContentSubtype.Promo:
            case ContentSubtype.Advert:
            case ContentSubtype.Safety:
            case ContentSubtype.ClientSpecific:
            case ContentSubtype.IndentWarning: {
                setAncillaryContent(item.content.ancillary.id, item.content.airline);

                break;
            }
        }
    };

    return { setContentFromLookupCloudAsset };
};
